/* ONORA – page produit : galerie, variantes, panier, fenêtres. Sans dépendance. */
(function () {
'use strict';
var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function scrollBox(el, left, top, smooth) {
if (smooth && !reduceMotion && typeof el.scrollTo === 'function') {
var options = { behavior: 'smooth' };
if (left !== null) options.left = left;
if (top !== null) options.top = top;
el.scrollTo(options);
return;
}
var previous = el.style.scrollBehavior;
el.style.scrollBehavior = 'auto';
if (left !== null) el.scrollLeft = left;
if (top !== null) el.scrollTop = top;
el.style.scrollBehavior = previous;
}
function scrollToX(el, left, smooth) {
scrollBox(el, left, null, smooth);
}
function formatMoney(cents, format) {
if (typeof cents === 'string') cents = cents.replace('.', '');
cents = parseInt(cents, 10) || 0;
format = format || (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
function withDelimiters(number, precision, thousands, decimal) {
thousands = typeof thousands === 'undefined' ? ',' : thousands;
decimal = typeof decimal === 'undefined' ? '.' : decimal;
var fixed = (number / 100).toFixed(precision);
var parts = fixed.split('.');
var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
var centsPart = parts[1] ? decimal + parts[1] : '';
return dollars + centsPart;
}
var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
var value = '';
switch (match ? match[1] : 'amount') {
case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
default: value = withDelimiters(cents, 2);
}
return match ? format.replace(match[0], value) : value;
}
function OnoraProduct(root) {
this.root = root;
var json = root.querySelector('[data-onora-json]');
try {
this.data = json ? JSON.parse(json.textContent) : { variants: [] };
} catch (e) {
this.data = { variants: [] };
}
this.track = root.querySelector('[data-onora-track]');
this.slides = this.track ? Array.prototype.slice.call(this.track.querySelectorAll('[data-onora-slide]')) : [];
this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-onora-thumb]'));
this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-onora-dot]'));
this.index = 0;
this.initGallery();
this.initOptions();
this.initQuantity();
this.initForm();
this.initDialogs();
this.initLightbox();
}
/* ---------- Galerie ---------- */
OnoraProduct.prototype.isSlider = function () {
if (!this.track) return false;
return window.getComputedStyle(this.track).display === 'flex';
};
OnoraProduct.prototype.goTo = function (index, instant) {
if (!this.slides.length) return;
var count = this.slides.length;
index = ((index % count) + count) % count;
this.index = index;
if (this.isSlider()) {
scrollToX(this.track, this.slides[index].offsetLeft, !instant);
}
this.setActive(index);
};
OnoraProduct.prototype.setActive = function (index) {
this.slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
this.thumbs.forEach(function (thumb, i) {
var active = i === index;
thumb.classList.toggle('is-active', active);
if (active) {
thumb.setAttribute('aria-current', 'true');
} else {
thumb.removeAttribute('aria-current');
}
});
this.dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
var activeThumb = this.thumbs[index];
var strip = activeThumb && activeThumb.parentElement;
if (strip) {
var stripRect = strip.getBoundingClientRect();
var thumbRect = activeThumb.getBoundingClientRect();
if (strip.scrollWidth > strip.clientWidth + 1) {
scrollBox(strip, strip.scrollLeft + (thumbRect.left - stripRect.left) - (strip.clientWidth - thumbRect.width) / 2, null, true);
} else if (strip.scrollHeight > strip.clientHeight + 1) {
scrollBox(strip, null, strip.scrollTop + (thumbRect.top - stripRect.top) - (strip.clientHeight - thumbRect.height) / 2, true);
}
}
};
OnoraProduct.prototype.initGallery = function () {
var self = this;
if (!this.track || !this.slides.length) return;
var startIndex = 0;
this.slides.forEach(function (slide, i) { if (slide.classList.contains('is-active')) startIndex = i; });
if (startIndex > 0) {
window.requestAnimationFrame(function () { self.goTo(startIndex, true); });
}
this.thumbs.forEach(function (thumb) {
thumb.addEventListener('click', function () { self.goTo(parseInt(thumb.getAttribute('data-index'), 10)); });
});
var prev = this.root.querySelector('[data-onora-prev]');
var next = this.root.querySelector('[data-onora-next]');
if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });
var ticking = false;
this.track.addEventListener('scroll', function () {
if (ticking || !self.isSlider()) return;
ticking = true;
window.requestAnimationFrame(function () {
var width = self.track.clientWidth || 1;
var i = Math.round(self.track.scrollLeft / width);
if (i !== self.index && i >= 0 && i < self.slides.length) {
self.index = i;
self.setActive(i);
}
ticking = false;
});
}, { passive: true });
this.track.addEventListener('keydown', function (e) {
if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
});
};
OnoraProduct.prototype.goToMedia = function (mediaId) {
if (!mediaId) return;
for (var i = 0; i < this.slides.length; i++) {
if (String(this.slides[i].getAttribute('data-media-id')) === String(mediaId)) {
if (this.isSlider()) {
this.goTo(i);
} else {
this.setActive(i);
}
return;
}
}
};
/* ---------- Variantes ---------- */
OnoraProduct.prototype.initOptions = function () {
var self = this;
this.optionInputs = Array.prototype.slice.call(this.root.querySelectorAll('[data-onora-option]'));
this.optionInputs.forEach(function (input) {
input.addEventListener('change', function () { self.onOptionChange(); });
});
if (this.optionInputs.length) this.updateAvailability(this.getSelectedOptions());
};
OnoraProduct.prototype.getSelectedOptions = function () {
var selected = [];
this.optionInputs.forEach(function (input) {
var idx = parseInt(input.getAttribute('data-onora-option'), 10);
if (input.tagName === 'SELECT') {
selected[idx] = input.value;
} else if (input.checked) {
selected[idx] = input.value;
}
});
return selected;
};
OnoraProduct.prototype.findVariant = function (options) {
var variants = this.data.variants || [];
for (var i = 0; i < variants.length; i++) {
var v = variants[i];
var ok = true;
for (var j = 0; j < v.options.length; j++) {
if (v.options[j] !== options[j]) { ok = false; break; }
}
if (ok) return v;
}
return null;
};
OnoraProduct.prototype.updateAvailability = function (selected) {
var variants = this.data.variants || [];
this.optionInputs.forEach(function (input) {
if (input.tagName === 'SELECT') return;
var idx = parseInt(input.getAttribute('data-onora-option'), 10);
var available = variants.some(function (v) {
if (v.options[idx] !== input.value || !v.available) return false;
for (var j = 0; j < v.options.length; j++) {
if (j !== idx && selected[j] !== undefined && v.options[j] !== selected[j]) return false;
}
return true;
});
var label = input.nextElementSibling;
if (label) label.classList.toggle('is-unavailable', !available);
});
};
OnoraProduct.prototype.onOptionChange = function () {
var selected = this.getSelectedOptions();
var root = this.root;
selected.forEach(function (value, idx) {
var el = root.querySelector('[data-onora-selected="' + idx + '"]');
if (el) el.textContent = value;
});
this.updateAvailability(selected);
var variant = this.findVariant(selected);
this.variant = variant;
this.updateButton(variant);
if (!variant) return;
var idInputs = root.querySelectorAll('[data-onora-variant-id]');
Array.prototype.forEach.call(idInputs, function (input) { input.value = variant.id; });
this.updatePrice(variant);
this.updateStock(variant);
if (variant.media_id) this.goToMedia(variant.media_id);
if (root.getAttribute('data-update-url') === 'true' && window.history && window.history.replaceState) {
try {
var url = new URL(window.location.href);
url.searchParams.set('variant', variant.id);
window.history.replaceState({}, '', url.toString());
} catch (e) { /* ignore */ }
}
root.dispatchEvent(new CustomEvent('onora:variant-change', { bubbles: true, detail: { variant: variant } }));
};
OnoraProduct.prototype.updatePrice = function (variant) {
var block = this.root.querySelector('[data-onora-price]');
if (!block) return;
var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
var current = block.querySelector('[data-onora-current-amount]');
if (current) current.textContent = formatMoney(variant.price);
var compare = block.querySelector('[data-onora-compare]');
var compareAmount = block.querySelector('[data-onora-compare-amount]');
if (compareAmount && onSale) compareAmount.textContent = formatMoney(variant.compare_at_price);
if (compare) compare.classList.toggle('is-hidden', !(onSale && block.getAttribute('data-show-compare') === 'true'));
var badge = block.querySelector('[data-onora-badge]');
if (badge) {
var type = block.getAttribute('data-badge');
if (type === 'percent' && onSale) {
badge.textContent = '-' + Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '%';
} else if (type === 'text') {
badge.textContent = block.getAttribute('data-badge-text') || '';
}
badge.classList.toggle('is-hidden', !(onSale && type !== 'none'));
}
};
OnoraProduct.prototype.updateStock = function (variant) {
var block = this.root.querySelector('[data-onora-stock]');
if (!block) return;
var threshold = parseInt(block.getAttribute('data-threshold'), 10) || 0;
var state = 'in';
var text = block.getAttribute('data-in') || '';
if (!variant.available) {
state = 'out';
text = block.getAttribute('data-out') || '';
} else if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny' && threshold > 0 && variant.inventory_quantity <= threshold) {
state = 'low';
text = (block.getAttribute('data-low') || '').replace('[count]', variant.inventory_quantity);
}
block.classList.remove('is-in', 'is-low', 'is-out');
block.classList.add('is-' + state);
var textEl = block.querySelector('[data-onora-stock-text]');
if (textEl) textEl.textContent = text;
};
OnoraProduct.prototype.updateButton = function (variant) {
var btn = this.root.querySelector('[data-onora-atc]');
if (!btn) return;
var textEl = btn.querySelector('[data-onora-atc-text]');
var label;
if (!variant) {
btn.disabled = true;
label = btn.getAttribute('data-text-unavailable');
} else if (!variant.available) {
btn.disabled = true;
label = btn.getAttribute('data-text-sold');
} else {
btn.disabled = false;
label = btn.getAttribute('data-text-add');
}
if (textEl && label) textEl.textContent = label;
};
/* ---------- Quantité ---------- */
OnoraProduct.prototype.initQuantity = function () {
var input = this.root.querySelector('[data-onora-qty-input]');
if (!input) return;
Array.prototype.forEach.call(this.root.querySelectorAll('[data-onora-qty]'), function (btn) {
btn.addEventListener('click', function () {
var step = parseInt(btn.getAttribute('data-onora-qty'), 10) || 0;
var value = (parseInt(input.value, 10) || 1) + step;
input.value = Math.max(1, value);
input.dispatchEvent(new Event('change', { bubbles: true }));
});
});
};
/* ---------- Panier ---------- */
OnoraProduct.prototype.initForm = function () {
var self = this;
var form = this.root.querySelector('.onora-pp__form');
var btn = this.root.querySelector('[data-onora-atc]');
if (!form || !btn) return;
var errorEl = this.root.querySelector('[data-onora-error]');
form.addEventListener('submit', function (e) {
e.preventDefault();
if (btn.disabled || btn.classList.contains('is-loading')) return;
btn.classList.add('is-loading');
btn.setAttribute('aria-busy', 'true');
if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
var routes = (window.theme && window.theme.routes) || {};
var body = new FormData(form);
fetch(routes.cartAdd || '/cart/add.js', {
method: 'POST',
headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
body: body
})
.then(function (response) {
return response.json().then(function (data) { return { ok: response.ok, data: data }; });
})
.then(function (result) {
if (!result.ok || result.data.status) {
throw new Error(result.data.description || result.data.message || 'Something went wrong. Please try again.');
}
var cartType = (window.theme && window.theme.settings && window.theme.settings.cartType) || self.root.getAttribute('data-cart-type');
if (cartType === 'page') {
window.location.href = routes.cartPage || '/cart';
return;
}
document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: result.data, addToCartBtn: btn } }));
self.root.dispatchEvent(new CustomEvent('onora:added', { bubbles: true, detail: { item: result.data } }));
window.setTimeout(function () {
var drawer = document.getElementById('CartDrawer');
if (drawer && !drawer.classList.contains('drawer--is-open')) {
var opener = document.querySelector('.js-drawer-open-cart');
if (opener) {
opener.click();
} else {
window.location.href = routes.cartPage || '/cart';
}
}
}, 900);
})
.catch(function (err) {
if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: err.message } }));
})
.then(function () {
btn.classList.remove('is-loading');
btn.removeAttribute('aria-busy');
});
});
};
/* ---------- Fenêtres ---------- */
OnoraProduct.prototype.initDialogs = function () {
var root = this.root;
Array.prototype.forEach.call(root.querySelectorAll('[data-onora-dialog-open]'), function (opener) {
opener.addEventListener('click', function () {
var dialog = document.getElementById(opener.getAttribute('data-onora-dialog-open'));
if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
dialog.showModal();
dialog._onoraOpener = opener;
}
});
});
Array.prototype.forEach.call(root.querySelectorAll('dialog'), function (dialog) {
dialog.addEventListener('click', function (e) {
if (e.target === dialog) dialog.close();
});
Array.prototype.forEach.call(dialog.querySelectorAll('[data-onora-dialog-close]'), function (btn) {
btn.addEventListener('click', function () { dialog.close(); });
});
dialog.addEventListener('close', function () {
if (dialog._onoraOpener && typeof dialog._onoraOpener.focus === 'function') dialog._onoraOpener.focus();
});
});
};
OnoraProduct.prototype.initLightbox = function () {
var root = this.root;
var box = root.querySelector('[data-onora-lightbox]');
if (!box || typeof box.showModal !== 'function') return;
var track = box.querySelector('[data-onora-lb-track]');
var slides = Array.prototype.slice.call(track.children);
function current() {
return Math.round(track.scrollLeft / (track.clientWidth || 1));
}
function show(i, instant) {
if (!slides.length) return;
i = ((i % slides.length) + slides.length) % slides.length;
scrollToX(track, slides[i].offsetLeft, !instant);
}
Array.prototype.forEach.call(root.querySelectorAll('[data-onora-zoom]'), function (btn) {
btn.addEventListener('click', function () {
box.showModal();
box._onoraOpener = btn;
var id = btn.getAttribute('data-media-id');
for (var i = 0; i < slides.length; i++) {
if (slides[i].getAttribute('data-media-id') === id) { show(i, true); break; }
}
});
});
var prev = box.querySelector('[data-onora-lb-prev]');
var next = box.querySelector('[data-onora-lb-next]');
if (prev) prev.addEventListener('click', function () { show(current() - 1); });
if (next) next.addEventListener('click', function () { show(current() + 1); });
box.addEventListener('keydown', function (e) {
if (e.key === 'ArrowRight') { e.preventDefault(); show(current() + 1); }
if (e.key === 'ArrowLeft') { e.preventDefault(); show(current() - 1); }
});
};
/* ---------- Démarrage ---------- */
function init(scope) {
Array.prototype.forEach.call((scope || document).querySelectorAll('[data-onora-pp]'), function (root) {
if (root._onoraProduct) return;
root._onoraProduct = new OnoraProduct(root);
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () { init(); });
} else {
init();
}
document.addEventListener('shopify:section:load', function (e) { init(e.target); });
document.addEventListener('shopify:block:select', function (e) {
var el = e.target;
if (el && el.matches && el.matches('details[data-onora-acc]')) el.open = true;
});
window.OnoraProduct = OnoraProduct;
})();
